import ApiCollection              from '@widesk-core/models/ApiCollection';
import { Box }                    from '@chakra-ui/react';
import CodeProperties             from '@/pages/Ticket/components/CodeProperties';
import CodePropertyValueModel     from '@/models/services/code/CodePropertyValueModel';
import ScheduleList               from '@/pages/Ticket/components/ScheduleList';
import { Text }                   from '@chakra-ui/react';
import { useTranslation }         from 'react-i18next';
import CodeTypePropertyValueModel from '@/models/services/code/CodeTypePropertyValueModel';
import CodeModel                  from '@/models/services/code/CodeModel.ts';

interface ICodeInformationProps {
	code: CodeModel;
	codePropertyValueCollection: ApiCollection<CodePropertyValueModel>;
	codeTypePropertyValueCollection: ApiCollection<CodeTypePropertyValueModel>;
}

const CodeInformation = (props: ICodeInformationProps) => {

	const { codePropertyValueCollection, codeTypePropertyValueCollection, code } = props;

	const { t } = useTranslation();

	return (
		<Box
			display="flex"
			flexDirection="column"
			gap="20px"
		>
			<Text className="poppins-semibold" fontSize="18px">{t('pages.ticket.codeProperties.title')}</Text>
			<Box
				display="flex"
				gap="20px"
			>
				<CodeProperties codePropertyValueCollection={codePropertyValueCollection} />
				{!code.codeType.source.product.multiVariant && (
					<ScheduleList codeTypePropertyValueCollection={codeTypePropertyValueCollection} />
				)}
			</Box>
		</Box>
	)
}

export default CodeInformation;